import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import MainScreenButton from '../../../../components/forms/mainScreenButton';
import {ctxReferralFormData, openPatientForm} from '../../../../store/reducers/patientContext';

const ReferralReviewButton = ({small, shortText = false}) => {
    const dispatch = useDispatch();
    const referralData = useSelector(ctxReferralFormData);

    if (!referralData) return null;

    const ecdsAcuity = () => {
        if(!shortText && referralData.ecdsAcuityScoreTitle && referralData.ecdsAcuityScore){
            return "Referral Review (" + referralData.ecdsAcuityScoreTitle + " " + referralData.ecdsAcuityScore + ")";
        }
        return "Referral Review";
    }

    const getAcuityScoreColor = () => {
        const ecdsAcuity = referralData.ecdsAcuityScore;

        if (!ecdsAcuity) {
            return 'transparent';
        }

        switch (ecdsAcuity) {
            case "1":
                return '#DC4A5D';
            case "2":
                return '#F26B28';
            case "3":
                return '#f7f700';
            case "4":
                return '#01AF69';
            case "5":
                return '#2180F7';
            default:
                return null;
        }
    };

    const getAcuityFontColor = () => {
        const color = getAcuityScoreColor();
        return color && color !== 'transparent' ? 'black' : '#2180f7';
    };

    const getAcuityBorder = () => {
        const color = getAcuityScoreColor();
        return color && color !== 'transparent' ? 'none' : '1px solid #2180f7';
    };

    return (
        <MainScreenButton
            buttonOnlyLabel={ecdsAcuity()}
            filledTextContainerBackground={getAcuityScoreColor()}
            filledTextContainerFontColor={getAcuityFontColor()}
            colorType="notMandatory"
            openFormPath="referral"
            onOpen={() => dispatch(openPatientForm('referralReview'))}
            userPath="by"
            buttonOnly
            filled
            datePath="date"
            filledTextContainerBorder={getAcuityBorder()}
            noWidth={small}
        />
    );
};

export default ReferralReviewButton;